export default __webpack_public_path__ + "static/media/login_pattern1.7378655d.svg";